module.exports = __webpack_public_path__ + "img/free-logo.5fb8a84b.png";